<!-- This file was generated with Github Copilot -->

<template>
  <div class="month-selector" style="width: 100%;">
    <button @click="previousMonth">&lt;</button>
    <span class="month">{{ selectedMonth.toLocaleString('default', { month: 'long', year: 'numeric' }) }}</span>
    <button @click="nextMonth">&gt;</button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      selectedMonth: this.value
    }
  },
  methods: {
    previousMonth() {
      const currentMonth = new Date(this.selectedMonth)
      currentMonth.setMonth(currentMonth.getMonth() - 1)
      this.selectedMonth = currentMonth
      this.$emit('input', this.selectedMonth)
    },
    nextMonth() {
      const currentMonth = new Date(this.selectedMonth)
      currentMonth.setMonth(currentMonth.getMonth() + 1)
      this.selectedMonth = currentMonth
      this.$emit('input', this.selectedMonth)
    }
  }
}
</script>

<style scoped>
.month-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  width: 100%;
}

.month-selector button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: inherit;
  padding: 0 1rem;
}

.month {
  width: 350px; /* set a fixed width for the span element */
  text-align: center; /* center the text within the span element */
}
</style>

